import MenuItem from './styles';

import AppContext from '../../../../../../services/context';

import Icon from '@map/components/Icons';
/**
 * Tooltip é uma ferramenta utilizada para especificar informações extras
 * sobre algo quando o usuário move o ponteiro do mouse sobre um elemento.
 */
import Tooltip from 'components/Tooltip';
/**
 * useContext usado para forcener uma maneira de passar dados
 * pela arvore de componentes sem ter que passar props manualmente
 * em todos os níveis.
 * 
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { useContext, useState } from 'react';
/**
 * useHistory é um hook utilizado para redirecionar para outra pagina.
 */
import { useHistory } from 'react-router-dom';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import { useModule } from 'views/MapView/hooks';

export default () => {
  const { closeSideBar } = useContext(AppContext);
  const { modules, activeModule } = useModule();

  const history = useHistory();
  const [expandedModule, setExpandedModule] = useState(null);

  const switchModule = (module) => {
    if (module.tipo_modulo !== 'externo') {
      history.push(module.endereco);
    } else {
      window.location.href = module.endereco;
    }
    setExpandedModule(null);
    closeSideBar();
  };

  return (
    <div className="items">
      {modules &&
        modules.map(
          (module, i) =>
            !module.draft &&
            module.st_ativo &&
            module.id !== (activeModule ? activeModule.id : 0) && (
              <MenuItem className="module" key={i}>
                <div onClick={() => switchModule(module)}>
                  <div>
                    <img src={module.icone} alt="Ícone do módulo" />
                    <h4>{module.titulo}</h4>
                    <Tooltip title="Descrição">
                      <button
                        className="desc-bt"
                        onClick={(e) => {
                          e.stopPropagation();
                          expandedModule && expandedModule === module.id
                            ? setExpandedModule(null)
                            : setExpandedModule(module.id);
                        }}
                      >
                        <Icon i="map-description" />
                      </button>
                    </Tooltip>
                  </div>
                  <div
                    className={`description ${
                      expandedModule && expandedModule === module.id
                        ? 'expanded'
                        : ''
                    }`}
                  >
                    <p>{module.descricao}</p>
                  </div>
                </div>
              </MenuItem>
            )
        )}
    </div>
  );
};
